export default env => {
  window.apolloEnv = env;
  if (env !== 'prod' && window.location.port) {
    window.apolloEnv = 'local';
  }

  import('./app/app.jsx');
};
